module.exports = __webpack_public_path__ + "static/hyperv_2.90460bdf.png";